__turbopack_context__.v({
  "cell--right": "X_vAQW_cell--right",
  "wrapper": "X_vAQW_wrapper",
});
